import { Search, Filter, TrendingUp, Sparkles } from "lucide-react";
import { GAMES, COACHES, GUIDES, EVENTS } from "@/lib/mockData";
import GameCard from "@/components/GameCard";
import CoachCard from "@/components/CoachCard";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

const QUICK_GOALS = ["Improve my Counter-Strike 2 aim", "Reach Immortal", "Learn jungle fundamentals", "Improve EA FC mechanics", "FNCS qualification prep"];

export default function Discover() {
  const [q, setQ] = useState("");
  const nav = useNavigate();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-10">
        <div className="eyebrow">EXPLORER PERFORM</div>
        <h1 data-testid="discover-title" className="font-display text-3xl font-semibold">Votre prochaine étape.</h1>
        <p className="mt-4 text-lg text-slate-300 max-w-2xl">Search coaches, guides, events, communities and training plans across every competitive title.</p>
        <div className="mt-6 glass rounded-2xl p-2 flex items-center gap-2 max-w-3xl">
          <Search className="w-5 h-5 text-slate-400 ml-3" />
          <input data-testid="discover-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Improve my Counter-Strike 2 aim…" className="flex-1 bg-transparent py-3 text-white placeholder:text-slate-500 focus:outline-none" />
          <button data-testid="discover-search-btn" onClick={() => nav(`/search?q=${encodeURIComponent(q)}`)} className="btn-primary text-white font-semibold px-5 py-3 rounded-xl text-sm">Rechercher</button>
        </div>
        <div className="mt-3 flex flex-wrap gap-2">
          {QUICK_GOALS.map(g => <button key={g} onClick={() => setQ(g)} className="px-3 py-1 rounded-full text-xs text-slate-300 border border-white/10 hover:border-blue-500/50 hover:text-blue-300 transition">{g}</button>)}
        </div>
      </div>

      <section className="mb-14">
        <div className="flex items-end justify-between mb-6">
          <h2 className="font-display text-2xl lg:text-3xl font-bold text-white">Popular Games</h2>
          <Link to="/games" className="text-sm text-slate-300 hover:text-white">Tout voir →</Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {GAMES.slice(0, 5).map(g => <GameCard key={g.slug} game={g} />)}
        </div>
      </section>

      <section className="mb-14">
        <div className="flex items-end justify-between mb-6">
          <div>
            <div className="text-xs uppercase tracking-widest text-violet-400 mb-1 inline-flex items-center gap-1"><TrendingUp className="w-3 h-3" /> Trending</div>
            <h2 className="font-display text-2xl lg:text-3xl font-bold text-white">Coaches on fire this week</h2>
          </div>
          <Link to="/coach" className="text-sm text-slate-300 hover:text-white">Le coach →</Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {COACHES.slice(0, 4).map(c => <CoachCard key={c.username} coach={c} />)}
        </div>
      </section>

      <section className="mb-14 grid lg:grid-cols-2 gap-6">
        <div className="glass rounded-2xl p-6">
          <h3 className="font-display text-xl font-bold text-white mb-4">Popular Guides</h3>
          <div className="space-y-3">
            {GUIDES.slice(0, 4).map(g => (
              <div key={g.id} className="flex items-center gap-3 p-3 rounded-lg hover:bg-white/5 transition">
                <img src={g.cover} alt={g.title} className="w-14 h-14 rounded-lg object-cover" />
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-white text-sm truncate">{g.title}</div>
                  <div className="text-xs text-slate-400">{g.author} · {g.game}</div>
                </div>
                <div className="text-sm font-bold text-blue-400">€{g.price}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="glass rounded-2xl p-6">
          <h3 className="font-display text-xl font-bold text-white mb-4">Upcoming Events</h3>
          <div className="space-y-3">
            {EVENTS.slice(0, 4).map(e => (
              <div key={e.id} className="flex items-center gap-3 p-3 rounded-lg hover:bg-white/5 transition">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-blue-500 to-violet-600 flex flex-col items-center justify-center text-white">
                  <div className="text-[10px] uppercase">{e.date.split(" ")[0]}</div>
                  <div className="font-bold">{e.date.split(" ")[1].replace(",","")}</div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-white text-sm truncate">{e.title}</div>
                  <div className="text-xs text-slate-400">{e.coach} · {e.participants}/{e.max}</div>
                </div>
                <div className="text-sm font-bold text-emerald-400">{e.price === 0 ? "FREE" : `€${e.price}`}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="glass rounded-3xl p-8 lg:p-12 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-violet-500/10" />
        <div className="relative">
          <h2 className="font-display text-3xl font-bold text-white mb-3">Vous ne savez pas par où commencer ?</h2>
          <p className="text-slate-300 max-w-lg mx-auto mb-6">Sélectionnez un jeu, un budget et une langue pour trouver un coach adapté.</p>
          <Link to="/smart-match" className="btn-primary text-white font-semibold px-6 py-3 rounded-full inline-flex items-center gap-2">Find My Perfect Coach</Link>
        </div>
      </section>
    </div>
  );
}
